<div class="content-wrapper pb-5 centros-estadisticas-container">
  <!-- Page Header -->
  <div class="page-title-box d-flex flex-wrap align-items-center justify-content-between mb-4">
    <div>
      <h3 class="page-title m-0 d-flex align-items-center">
        <div class="title-icon-badge mr-3">
          <i class="fas fa-chart-pie"></i>
        </div>
        <span>Estadísticas de Centros Médicos</span>
      </h3>
      <p class="text-muted small mb-0 mt-1">Consulte la distribución geográfica, por rubro y especialidad de la red de prestadores</p>
    </div>
    <div class="d-flex align-items-center flex-wrap">
      <button mat-raised-button color="primary" class="mr-2 mt-2 mt-sm-0" (click)="exportarExcel()" [disabled]="isLoading || !stats">
        <i class="fas fa-file-excel mr-2"></i> Exportar Excel
      </button>
      <a class="btn btn-outline-brand rounded-pill px-4 mt-2 mt-sm-0 d-inline-flex align-items-center font-weight-bold" [routerLink]="['/estadisticas-sistema']">
        <i class="fas fa-arrow-left mr-2"></i> Volver a Estadísticas
      </a>
    </div>
  </div>

  <!-- Filtros de Búsqueda ocultos por el momento
  <div class="card filter-card mb-4 border-0 shadow-sm">
    <div class="card-body p-4">
      <div class="d-flex align-items-center mb-3">
        <i class="fas fa-filter text-brand mr-2"></i>
        <h6 class="font-weight-bold m-0 text-uppercase tracking-wide text-dark" style="font-size: 0.85rem;">Filtros de Búsqueda</h6>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 col-lg-3 mb-3">
          <label class="filter-label">Provincia</label>
          <div class="select-wrapper">
            <select class="form-control custom-select-styled" [(ngModel)]="filtros.provinciaId" (ngModelChange)="onProvinciaChange()">
              <option value="">Todas las provincias</option>
              <option *ngFor="let p of provincias" [value]="p._id">{{ p.nombre }}</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-3 mb-3">
          <label class="filter-label">Localidad</label>
          <div class="select-wrapper">
            <select class="form-control custom-select-styled" [(ngModel)]="filtros.localidadId" (ngModelChange)="aplicar()">
              <option value="">Todas las localidades</option>
              <option *ngFor="let l of localidades" [value]="l._id">{{ l.nombre }}</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-3 mb-3">
          <label class="filter-label">Rubro</label>
          <div class="select-wrapper">
            <select class="form-control custom-select-styled" [(ngModel)]="filtros.rubroId" (ngModelChange)="aplicar()">
              <option value="">Todos los rubros</option>
              <option *ngFor="let r of rubros" [value]="r._id">{{ r.concepto }}</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-3 mb-3">
          <label class="filter-label">Especialidad</label>
          <div class="select-wrapper">
            <select class="form-control custom-select-styled" [(ngModel)]="filtros.especialidadId" (ngModelChange)="aplicar()">
              <option value="">Todas las especialidades</option>
              <option *ngFor="let e of especialidades" [value]="e._id">{{ e.concepto }}</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-3 mb-3">
          <label class="filter-label">Gerenciadora</label>
          <div class="select-wrapper">
            <select class="form-control custom-select-styled" [(ngModel)]="filtros.gerenciadoraId" (ngModelChange)="aplicar()">
              <option value="">Todas las gerenciadoras</option>
              <option *ngFor="let g of gerenciadoras" [value]="g._id">{{ g.nombre }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center flex-wrap pt-2 border-top">
        <button mat-raised-button color="primary" class="btn-brand-primary px-4 mr-2" (click)="aplicar()" [disabled]="isLoading">
          <i class="fas fa-search mr-1"></i> Aplicar filtros
        </button>
        <button mat-button class="btn-brand-outline" (click)="limpiar()" [disabled]="isLoading">
          <i class="fas fa-undo-alt mr-1"></i> Limpiar
        </button>
        <div class="chips-container ml-auto d-flex flex-wrap align-items-center mt-2 mt-md-0">
          <span class="filter-chip-pill mr-1 mb-1" *ngFor="let c of chipsActivos">
            <i class="fas fa-check-circle mr-1"></i> {{ c.label }}
          </span>
        </div>
      </div>
    </div>
  </div>
  -->

  <!-- Loading State -->
  <div *ngIf="isLoading" class="d-flex flex-column justify-content-center align-items-center py-5 my-5">
    <div class="spinner-border text-brand" role="status" style="width: 3.5rem; height: 3.5rem; border-width: 0.25em;">
      <span class="sr-only">Cargando...</span>
    </div>
    <p class="text-muted font-weight-bold mt-3">Cargando estadísticas...</p>
  </div>

  <ng-container *ngIf="!isLoading && stats">
    <!-- Indicadores KPI -->
    <div class="row mb-4">
      <div class="col-12 col-md-4 mb-3 mb-md-0">
        <div class="stat-kpi-card card border-0 shadow-sm h-100 kpi-primary">
          <div class="card-body d-flex align-items-center justify-content-between p-4">
            <div>
              <span class="kpi-label">Centros Médicos</span>
              <div class="kpi-value">{{ stats.totalCentros }}</div>
              <div class="d-flex flex-column">
                <span class="kpi-subtext"><i class="fas fa-check-circle text-success mr-1"></i> Activos: <b>{{ stats.totalActivos }}</b></span>
                <span class="kpi-subtext"><i class="fas fa-ban text-danger mr-1"></i> Inactivos: <b>{{ stats.totalInactivos }}</b></span>
              </div>
            </div>
            <div class="kpi-icon-wrapper">
              <i class="fas fa-hospital"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-4 mb-3 mb-md-0">
        <div class="stat-kpi-card card border-0 shadow-sm h-100 kpi-info">
          <div class="card-body d-flex align-items-center justify-content-between p-4">
            <div>
              <span class="kpi-label">Especialidades</span>
              <div class="kpi-value">{{ stats.totalEspecialidades }}</div>
              <span class="kpi-subtext"><i class="fas fa-notes-medical mr-1"></i> Cobertura médica</span>
            </div>
            <div class="kpi-icon-wrapper">
              <i class="fas fa-stethoscope"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-4 mb-3 mb-md-0">
        <div class="stat-kpi-card card border-0 shadow-sm h-100 kpi-success">
          <div class="card-body d-flex align-items-center justify-content-between p-4">
            <div>
              <span class="kpi-label">Rubros</span>
              <div class="kpi-value">{{ stats.totalRubros }}</div>
              <span class="kpi-subtext"><i class="fas fa-layer-group mr-1"></i> Categorías de atención</span>
            </div>
            <div class="kpi-icon-wrapper">
              <i class="fas fa-tags"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Distribuciones (colapsables) -->
    <mat-accordion class="stats-accordion mb-4">
      <!-- Centros Deshabilitados -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <i class="fas fa-ban text-danger mr-2"></i> Centros Deshabilitados
          </mat-panel-title>
          <mat-panel-description class="justify-content-end">
            <span class="badge badge-soft-danger">{{ stats.totalInactivos }} deshabilitados</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="card-body px-4 py-3">
          <p class="mb-2">
            <i class="fas fa-info-circle text-muted mr-1"></i>
            Centros marcados como inactivos: <b>{{ stats.totalInactivos }}</b>.
          </p>
          <button mat-raised-button color="warn" [disabled]="!stats.totalInactivos" (click)="verCentrosDeshabilitados()">
            <i class="fas fa-eye mr-2"></i> Ver centros deshabilitados
          </button>
        </div>
      </mat-expansion-panel>

      <!-- Por Provincia -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <i class="fas fa-map-marked-alt text-brand mr-2"></i> Distribución por Provincia
          </mat-panel-title>
          <mat-panel-description class="justify-content-end">
            <span class="badge badge-soft-brand">{{ stats.porProvincia.length }} Provincias</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="card-body px-4 py-3">
          <div class="province-bar-item mb-3" *ngFor="let p of stats.porProvincia">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="font-weight-bold text-dark">
                <i class="fas fa-map-marker-alt text-muted mr-1"></i> {{ p.provincia }}
              </span>
              <div class="d-flex align-items-center">
                <span class="badge badge-pill badge-brand-count mr-2">{{ p.totalCentros }} centros</span>
                <a href="javascript:void(0)" class="btn-link-action" (click)="verCentrosProvincia(p.provincia)" title="Ver centros de {{ p.provincia }}">
                  <i class="fas fa-eye mr-1"></i> Ver centros
                </a>
              </div>
            </div>
            <div class="progress custom-progress">
              <div class="progress-bar custom-progress-bar" role="progressbar" [style.width.%]="anchoBarra(p.totalCentros)"></div>
            </div>
          </div>
          <div class="text-center text-muted py-4" *ngIf="!stats.porProvincia.length">
            <i class="fas fa-folder-open fa-2x mb-2 text-muted opacity-50"></i>
            <p class="small mb-0">Sin datos de provincias para los filtros seleccionados.</p>
          </div>
        </div>
      </mat-expansion-panel>

      <!-- Por Localidad -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <i class="fas fa-city text-primary-accent mr-2"></i> Distribución por Localidad
          </mat-panel-title>
          <mat-panel-description class="justify-content-end">
            <span class="badge badge-soft-info">{{ stats.porLocalidad.length }} Localidades</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="custom-scroll-table" style="max-height: 400px; overflow-y: auto;">
          <table class="table table-hover align-middle mb-0 custom-styled-table">
            <thead class="sticky-top bg-light">
              <tr>
                <th>Localidad</th>
                <th>Provincia</th>
                <th>Zona</th>
                <th class="text-right">Centros</th>
                <th class="text-right">Ver</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let l of stats.porLocalidad">
                <td class="font-weight-bold text-dark">{{ l.localidad }}</td>
                <td class="text-muted small"><span class="prov-tag">{{ l.provincia }}</span></td>
                <td class="text-muted small">{{ l.zona || '-' }}</td>
                <td class="text-right">
                  <span class="count-badge">{{ l.totalCentros }}</span>
                </td>
                <td class="text-right">
                  <a href="javascript:void(0)" class="btn-link-action" (click)="verCentrosLocalidad(l.localidad)" title="Ver centros de {{ l.localidad }}">
                    <i class="fas fa-eye mr-1"></i> Ver centros
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center text-muted py-4" *ngIf="!stats.porLocalidad.length">
            <i class="fas fa-folder-open fa-2x mb-2 text-muted opacity-50"></i>
            <p class="small mb-0">Sin datos de localidades.</p>
          </div>
        </div>
      </mat-expansion-panel>

      <!-- Por Gerenciadora -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <i class="fas fa-building text-warning mr-2"></i> Distribución por Gerenciadora
          </mat-panel-title>
          <mat-panel-description class="justify-content-end">
            <span class="badge badge-soft-warning">{{ stats.porGerenciadora.length }} Gerenciadoras</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="custom-scroll-table" style="max-height: 380px; overflow-y: auto;">
          <table class="table table-hover align-middle mb-0 custom-styled-table">
            <thead class="sticky-top bg-light">
              <tr>
                <th>Gerenciadora</th>
                <th class="text-right">Centros</th>
                <th class="text-right">Ver</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let g of stats.porGerenciadora">
                <td class="font-weight-bold text-dark">{{ g.gerenciadora }}</td>
                <td class="text-right">
                  <span class="count-badge count-badge-warning">{{ g.totalCentros }}</span>
                </td>
                <td class="text-right">
                  <a href="javascript:void(0)" class="btn-link-action" *ngIf="g.gerenciadoraId" (click)="verCentrosGerenciadora(g)" title="Ver centros de {{ g.gerenciadora }}">
                    <i class="fas fa-eye mr-1"></i> Ver centros
                  </a>
                  <span class="text-muted small" *ngIf="!g.gerenciadoraId">-</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center text-muted py-4" *ngIf="!stats.porGerenciadora.length">
            <i class="fas fa-folder-open fa-2x mb-2 text-muted opacity-50"></i>
            <p class="small mb-0">Sin datos de gerenciadoras.</p>
          </div>
        </div>
      </mat-expansion-panel>

      <!-- Por Zona -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <i class="fas fa-map-signs text-info mr-2"></i> Distribución por Zona
          </mat-panel-title>
          <mat-panel-description class="justify-content-end">
            <span class="badge badge-soft-info">{{ stats.porZona.length }} Zonas</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="custom-scroll-table" style="max-height: 380px; overflow-y: auto;">
          <table class="table table-hover align-middle mb-0 custom-styled-table">
            <thead class="sticky-top bg-light">
              <tr>
                <th>Zona</th>
                <th class="text-right">Centros</th>
                <th class="text-right">Ver</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let z of stats.porZona">
                <td class="font-weight-bold text-dark">{{ z.zona }}</td>
                <td class="text-right">
                  <span class="count-badge count-badge-info">{{ z.totalCentros }}</span>
                </td>
                <td class="text-right">
                  <ng-container *ngIf="z.zonaId">
                    <a href="javascript:void(0)" class="btn-link-action" (click)="verCentrosZona(z)" title="Ver centros de {{ z.zona }}">
                      <i class="fas fa-eye mr-1"></i> Centros
                    </a>
                    <a href="javascript:void(0)" class="btn-link-action ml-2" (click)="verLocalidadesZona(z)" title="Ver localidades de {{ z.zona }}">
                      <i class="fas fa-map-marker-alt mr-1"></i> Localidades
                    </a>
                  </ng-container>
                  <span class="text-muted small" *ngIf="!z.zonaId">-</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center text-muted py-4" *ngIf="!stats.porZona.length">
            <i class="fas fa-folder-open fa-2x mb-2 text-muted opacity-50"></i>
            <p class="small mb-0">Sin datos de zonas.</p>
          </div>
        </div>
      </mat-expansion-panel>

      <!-- Por Rubro -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <i class="fas fa-tags text-success mr-2"></i> Por Rubro
          </mat-panel-title>
          <mat-panel-description class="justify-content-end">
            <span class="badge badge-soft-success">{{ stats.porRubro.length }} Rubros</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="custom-scroll-table" style="max-height: 380px; overflow-y: auto;">
          <table class="table table-hover align-middle mb-0 custom-styled-table">
            <thead class="sticky-top bg-light">
              <tr>
                <th>Rubro</th>
                <th class="text-right">Centros</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of stats.porRubro">
                <td class="font-weight-bold text-dark">{{ r.rubro }}</td>
                <td class="text-right">
                  <span class="count-badge count-badge-success">{{ r.totalCentros }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center text-muted py-4" *ngIf="!stats.porRubro.length">
            <i class="fas fa-folder-open fa-2x mb-2 text-muted opacity-50"></i>
            <p class="small mb-0">Sin datos de rubros.</p>
          </div>
        </div>
      </mat-expansion-panel>

      <!-- Por Especialidad -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <i class="fas fa-stethoscope text-info mr-2"></i> Por Especialidad
          </mat-panel-title>
          <mat-panel-description class="justify-content-end">
            <span class="badge badge-soft-info">{{ stats.porEspecialidad.length }} Especialidades</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="custom-scroll-table" style="max-height: 380px; overflow-y: auto;">
          <table class="table table-hover align-middle mb-0 custom-styled-table">
            <thead class="sticky-top bg-light">
              <tr>
                <th>Especialidad</th>
                <th class="text-right">Centros</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let e of stats.porEspecialidad">
                <td class="font-weight-bold text-dark">{{ e.especialidad }}</td>
                <td class="text-right">
                  <span class="count-badge count-badge-info">{{ e.totalCentros }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center text-muted py-4" *ngIf="!stats.porEspecialidad.length">
            <i class="fas fa-folder-open fa-2x mb-2 text-muted opacity-50"></i>
            <p class="small mb-0">Sin datos de especialidades.</p>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- Nota Informativa de Conteo -->
    <div class="alert custom-info-callout border-0 shadow-sm rounded-lg mb-4 p-3 d-flex align-items-start">
      <div class="callout-icon mr-3 text-info">
        <i class="fas fa-info-circle fa-lg"></i>
      </div>
      <div class="callout-text small text-dark">
        <strong>Nota metodológica:</strong> En <b>total de centros</b>, <b>provincia</b> y <b>localidad</b> cada centro médico se contabiliza una sola vez. En <b>rubro</b> y <b>especialidad</b>, un centro se cuenta por cada categoría con la que opera; por tal motivo, la suma acumulada de rubros o especialidades puede superar el número total de centros.
      </div>
    </div>

    <!-- Grilla de Detalle -->
    <div class="card detail-grid-card border-0 shadow-sm">
      <div class="card-header bg-white border-bottom py-3 px-4 d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex align-items-center mb-2 mb-md-0">
          <i class="fas fa-list-ul text-brand mr-2"></i>
          <h6 class="m-0 font-weight-bold text-dark">
            Detalle de Centros Médicos
          </h6>
          <span class="badge badge-brand-count ml-2">{{ totalCentrosGrid }}</span>
        </div>

        <div class="search-box-wrapper">
          <i class="fas fa-search search-icon"></i>
          <input
            type="text"
            class="form-control form-control-sm search-input"
            placeholder="Buscar por nombre, localidad, dirección, especialidad..."
            [(ngModel)]="busqueda"
            (ngModelChange)="onBusqueda()"
          />
        </div>
      </div>

      <div class="card-body p-0">
        <mat-progress-bar *ngIf="isLoadingGrid" mode="indeterminate" class="grid-loading-bar"></mat-progress-bar>
        <div class="table-responsive">
          <table class="table table-hover align-middle mb-0 custom-styled-table grid-table">
            <thead>
              <tr>
                <th>Centro Médico</th>
                <th>Localidad</th>
                <th>Provincia</th>
                <th>Gerenciadora</th>
                <th>Dirección</th>
                <th>Especialidades</th>
                <th>Rubros</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of centrosPage">
                <td class="font-weight-bold text-dark text-nowrap">
                  <i class="fas fa-clinic-medical text-brand-light mr-2"></i>{{ c.nombre }}
                </td>
                <td>{{ c.localidad }}</td>
                <td><span class="prov-tag">{{ c.provincia }}</span></td>
                <td><span class="ger-tag">{{ c.gerenciadora || '-' }}</span></td>
                <td class="small text-muted">{{ c.direccion || '-' }}</td>
                <td>
                  <div class="d-flex flex-wrap gap-1">
                    <span class="badge-item-tag tag-especialidad" *ngFor="let esp of c.especialidades">
                      {{ esp }}
                    </span>
                    <span class="text-muted small" *ngIf="!c.especialidades?.length">-</span>
                  </div>
                </td>
                <td>
                  <div class="d-flex flex-wrap gap-1">
                    <span class="badge-item-tag tag-rubro" *ngFor="let rub of c.rubros">
                      {{ rub }}
                    </span>
                    <span class="text-muted small" *ngIf="!c.rubros?.length">-</span>
                  </div>
                </td>
              </tr>

              <tr *ngIf="!centrosPage.length && !isLoadingGrid">
                <td colspan="7" class="text-center text-muted py-5">
                  <i class="fas fa-search fa-3x mb-3 text-muted opacity-40"></i>
                  <p class="font-weight-bold mb-1">No se encontraron centros médicos</p>
                  <p class="small text-muted mb-0">Pruebe modificando los términos de búsqueda o los filtros seleccionados.</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div class="d-flex flex-wrap justify-content-between align-items-center p-3 bg-light border-top pagination-bar">
          <button mat-button class="btn-pagination" [disabled]="page === 0 || isLoadingGrid" (click)="paginaAnterior()">
            <i class="fas fa-chevron-left mr-1"></i> Anterior
          </button>

          <span class="small font-weight-bold text-muted my-1">
            Página {{ page + 1 }} de {{ totalPaginas }} ({{ totalCentrosGrid }} registros)
          </span>

          <button mat-button class="btn-pagination" [disabled]="page + 1 >= totalPaginas || isLoadingGrid" (click)="paginaSiguiente()">
            Siguiente <i class="fas fa-chevron-right ml-1"></i>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>

